import React, { useEffect, useState } from 'react';
import KierowcaTemplate from 'templates/KierowcaTemplate';
import ZamowienieKontrahenci from 'components/molecules/ZamowienieKontrahenci/ZamowienieKontrahenci';
import { useParams, NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { sortableContainer, sortableElement } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from 'components/atoms/Button/Button';
import {
  pobierzKierowcaFirmyAction,
  zapiszKolejnoscFirmyAction,
} from 'services/kierowcaZamowieniaService';
import { WybraniKontrahenciWrapper, Btn } from './style';

const StyledNavLink = styled(NavLink)`
  &:hover {
    text-decoration: none;
  }
`;

const StyledHeadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SortableItem = sortableElement(({ kontrahent, idGodziny }) => (
  <Btn
    onMouseDown={e => e.preventDefault()}
    type="button"
    as={StyledNavLink}
    to={`${idGodziny}/kontrahent/${kontrahent.idContractor}${
      kontrahent.oddzialId ? `/${kontrahent.oddzialId}` : ''
    }`}
  >
    <ZamowienieKontrahenci
      key={`${kontrahent.idContractor}_${kontrahent.oddzialId}`}
      nazwa={`${kontrahent.contractorName}${
        kontrahent.miasto !== 'Bielsko-Biała' ? `(${kontrahent.miasto})` : ''
      }${kontrahent.oddzial ? `(${kontrahent.oddzial})` : ''}`}
      ilosc={kontrahent.dishNumber}
      zupy={kontrahent.zupyNumber}
      smoothie={kontrahent.smoothieNumber}
      salatki={kontrahent.salatkiNumber}
      deser={kontrahent.deserNumber}
      glowne={kontrahent.glowneNumber}
      doOplacenia={kontrahent.paymentCount}
    />
  </Btn>
));

const SortableList = sortableContainer(({ items, idGodziny, pobierzFirmy, zapiszKolejnosc }) => (
  <div>
    {items.map((kontrahent, index) => (
      <SortableItem
        key={`${kontrahent.idContractor}_${kontrahent.oddzialId}`}
        index={index}
        kontrahent={kontrahent}
        idGodziny={idGodziny}
        pobierzFirmy={pobierzFirmy}
        zapiszKolejnosc={zapiszKolejnosc}
      />
    ))}
  </div>
));

const WybraniKontrahenci = ({ kontrahenci, pobierzFirmy, zapiszKolejnosc }) => {
  const { id: idGodziny } = useParams();
  const [items, setItems] = useState([]);
  useEffect(() => {
    setItems(kontrahenci);
  }, [kontrahenci]);

  const handleSortEnd = ({ oldIndex, newIndex }) => {
    const newItems = arrayMove(items, oldIndex, newIndex);
    setItems(newItems);
    zapiszKolejnosc(idGodziny, newItems).then(() => pobierzFirmy(idGodziny));
  };
  const { id } = useParams();

  const StyledButton = styled(Button)`
    margin-top: 2rem;
  `;

  useEffect(() => {
    pobierzFirmy(id);
  }, []);

  return (
    <KierowcaTemplate>
      <StyledHeadWrapper>
        <StyledButton nopadding onClick={() => pobierzFirmy(id)}>
          Odśwież
        </StyledButton>
      </StyledHeadWrapper>

      <WybraniKontrahenciWrapper>
        {items.length > 0 && (
          <SortableList
            items={items}
            onSortEnd={handleSortEnd}
            useDragHandle={false}
            idGodziny={idGodziny}
            pobierzFirmy={pobierzFirmy}
            zapiszKolejnosc={zapiszKolejnosc}
          />
        )}
        {/* Summary row */}
        <ZamowienieKontrahenci
          key={-1}
          nazwa="Suma"
          visibility
          ilosc={kontrahenci.reduce((sum, a) => sum + a.dishNumber, 0)}
          zupy={kontrahenci.reduce((sum, a) => sum + a.zupyNumber, 0)}
          smoothie={kontrahenci.reduce((sum, a) => sum + a.smoothieNumber, 0)}
          salatki={kontrahenci.reduce((sum, a) => sum + a.salatkiNumber, 0)}
          deser={kontrahenci.reduce((sum, a) => sum + a.deserNumber, 0)}
          glowne={kontrahenci.reduce((sum, a) => sum + a.glowneNumber, 0)}
          doOplacenia={kontrahenci.reduce((sum, a) => sum + a.paymentCount, 0)}
        />
      </WybraniKontrahenciWrapper>
    </KierowcaTemplate>
  );
};

WybraniKontrahenci.propTypes = {
  kontrahenci: PropTypes.arrayOf(PropTypes.shape({})),
  pobierzFirmy: PropTypes.func,
  zapiszKolejnosc: PropTypes.func,
};

WybraniKontrahenci.defaultProps = {
  kontrahenci: [],
  pobierzFirmy: null,
  zapiszKolejnosc: null,
};

const mapStateToProps = state => ({
  kontrahenci: state.kierowcaReducer.kontrahenci,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      pobierzFirmy: pobierzKierowcaFirmyAction,
      zapiszKolejnosc: zapiszKolejnoscFirmyAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(WybraniKontrahenci);
